var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "second-step-box" },
    [
      _vm.secondStepCopy == 1
        ? _c("div", [
            _c("h2", { staticClass: "bold title" }, [
              _vm._v(_vm._s(_vm.$t("8000123")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form" }, [
              !_vm.$parent.existFlag && _vm.$parent.protocol == "SOLANA"
                ? _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("p", { staticClass: "label required-fields" }, [
                        _vm._v(_vm._s(_vm.$t("8000068")))
                      ]),
                      _vm._v(" "),
                      _c("van-field", {
                        staticClass: "value",
                        class: { errorClass: !!_vm.currencyLimitMsg },
                        attrs: {
                          type: "textarea",
                          rows: "1",
                          autosize: "",
                          disabled:
                            _vm.currencyDetails &&
                            !!_vm.currencyDetails.currency,
                          clearable: "",
                          maxlength: "9",
                          autocomplete: "off",
                          placeholder: _vm.$t("10000016")
                        },
                        on: {
                          blur: _vm.handleCurrencyBlur,
                          focus: function($event) {
                            _vm.currencyLimitMsg = ""
                          }
                        },
                        model: {
                          value: _vm.secondTemp.currency,
                          callback: function($$v) {
                            _vm.$set(_vm.secondTemp, "currency", $$v)
                          },
                          expression: "secondTemp.currency"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.currencyLimitMsg,
                              expression: "!currencyLimitMsg"
                            }
                          ],
                          staticClass: "tip-msg-style"
                        },
                        [_vm._v(_vm._s(_vm.$t("8000155")))]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "error-msg-style" }, [
                        _vm._v(_vm._s(_vm.currencyLimitMsg))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$parent.existFlag && _vm.$parent.protocol == "SOLANA"
                ? _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("p", { staticClass: "label required-fields" }, [
                        _vm._v(_vm._s(_vm.$t("8000119")))
                      ]),
                      _vm._v(" "),
                      _c("van-field", {
                        staticClass: "value",
                        class: { errorClass: !!_vm.currencyFullLimitMsg },
                        attrs: {
                          type: "textarea",
                          rows: "1",
                          autosize: "",
                          disabled:
                            _vm.currencyDetails &&
                            !!_vm.currencyDetails.currencyFull,
                          clearable: "",
                          maxlength: "50",
                          autocomplete: "off",
                          placeholder: _vm.$t("10000017")
                        },
                        on: {
                          blur: _vm.handleCurrencyFullBlur,
                          focus: function($event) {
                            _vm.currencyFullLimitMsg = ""
                          }
                        },
                        model: {
                          value: _vm.secondTemp.currencyFull,
                          callback: function($$v) {
                            _vm.$set(_vm.secondTemp, "currencyFull", $$v)
                          },
                          expression: "secondTemp.currencyFull"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.currencyFullLimitMsg,
                              expression: "!currencyFullLimitMsg"
                            }
                          ],
                          staticClass: "tip-msg-style"
                        },
                        [_vm._v(_vm._s(_vm.$t("8000156")))]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "error-msg-style" }, [
                        _vm._v(_vm._s(_vm.currencyFullLimitMsg))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$parent.existFlag && _vm.$parent.protocol == "ARC20"
                ? _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("p", { staticClass: "label required-fields" }, [
                        _vm._v(_vm._s(_vm.$t("10000010")))
                      ]),
                      _vm._v(" "),
                      _c("van-field", {
                        staticClass: "value",
                        class: { errorClass: !!_vm.totalIssueAmountLimitMsg },
                        attrs: {
                          type: "textarea",
                          rows: "1",
                          autosize: "",
                          disabled:
                            _vm.currencyDetails &&
                            !!_vm.currencyDetails.totalIssueAmount,
                          clearable: "",
                          autocomplete: "off",
                          placeholder: _vm.$t("8000135")
                        },
                        on: {
                          blur: _vm.handleTotalIssueAmountBlur,
                          focus: function($event) {
                            _vm.totalIssueAmountLimitMsg = ""
                          }
                        },
                        model: {
                          value: _vm.secondTemp.totalIssueAmount,
                          callback: function($$v) {
                            _vm.$set(_vm.secondTemp, "totalIssueAmount", $$v)
                          },
                          expression: "secondTemp.totalIssueAmount"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "error-msg-style" }, [
                        _vm._v(_vm._s(_vm.totalIssueAmountLimitMsg))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$parent.existFlag
                ? _c(
                    "div",
                    { staticClass: "form-item priceTick-input" },
                    [
                      _c(
                        "p",
                        { staticClass: "label required-fields" },
                        [
                          _vm._v(_vm._s(_vm.$t("8000120")) + "\n          "),
                          _c("van-icon", {
                            attrs: { name: "warning-o" },
                            on: {
                              click: function($event) {
                                _vm.priceTickTipModel = true
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "number-buttons" }, [
                        _c(
                          "span",
                          {
                            staticClass: "inline-block",
                            class: {
                              activeNumberButton: _vm.priceTickNum == 2
                            },
                            on: {
                              click: function($event) {
                                return _vm.changePriceTick(2)
                              }
                            }
                          },
                          [_vm._v("2")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "inline-block",
                            class: {
                              activeNumberButton: _vm.priceTickNum == 4
                            },
                            on: {
                              click: function($event) {
                                return _vm.changePriceTick(4)
                              }
                            }
                          },
                          [_vm._v("4")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "inline-block",
                            class: {
                              activeNumberButton: _vm.priceTickNum == 11
                            },
                            on: {
                              click: function($event) {
                                return _vm.changePriceTick(11)
                              }
                            }
                          },
                          [_vm._v("11")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "inline-block",
                            class: {
                              activeNumberButton: _vm.priceTickNum == 12
                            },
                            on: {
                              click: function($event) {
                                return _vm.changePriceTick(12)
                              }
                            }
                          },
                          [_vm._v("12")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("van-field", {
                        staticClass: "value",
                        class: { errorClass: !!_vm.priceTickLimitMsg },
                        attrs: {
                          autocomplete: "off",
                          placeholder: _vm.$t("8000135")
                        },
                        on: {
                          input: _vm.handlePriceTickInput,
                          focus: function($event) {
                            _vm.priceTickNum = ""
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "left-icon",
                              fn: function() {
                                return [
                                  _c("van-button", {
                                    attrs: {
                                      disabled: _vm.secondTemp.priceTick == 0,
                                      icon: "minus"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.secondTemp.priceTick--
                                        _vm.priceTickNum = ""
                                      }
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "right-icon",
                              fn: function() {
                                return [
                                  _c("van-button", {
                                    attrs: {
                                      disabled: _vm.secondTemp.priceTick == 12,
                                      icon: "plus"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.secondTemp.priceTick++
                                        _vm.priceTickNum = ""
                                      }
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          2353700727
                        ),
                        model: {
                          value: _vm.secondTemp.priceTick,
                          callback: function($$v) {
                            _vm.$set(_vm.secondTemp, "priceTick", $$v)
                          },
                          expression: "secondTemp.priceTick"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$parent.existFlag
                ? _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("p", { staticClass: "label required-fields" }, [
                        _vm._v(_vm._s(_vm.$t("8000122")))
                      ]),
                      _vm._v(" "),
                      _c("van-field", {
                        staticClass: "value",
                        class: { errorClass: !!_vm.contentLimitMsg },
                        attrs: {
                          autosize: "",
                          rows: "4",
                          "show-word-limit": "",
                          type: "textarea",
                          disabled:
                            _vm.currencyDetails &&
                            !!_vm.currencyDetails.content,
                          clearable: "",
                          maxlength: "20000",
                          autocomplete: "off",
                          placeholder: _vm.$t("8000140")
                        },
                        model: {
                          value: _vm.secondTemp.content,
                          callback: function($$v) {
                            _vm.$set(_vm.secondTemp, "content", $$v)
                          },
                          expression: "secondTemp.content"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c(
                    "p",
                    { staticClass: "label required-fields" },
                    [
                      _vm._v(_vm._s(_vm.$t("8000071")) + "\n          "),
                      _c("van-icon", {
                        attrs: { name: "warning-o" },
                        on: {
                          click: function($event) {
                            _vm.memoTipModel = true
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("van-field", {
                    staticClass: "value",
                    class: { errorClass: !!_vm.memoLimitMsg },
                    attrs: {
                      type: "textarea",
                      rows: "1",
                      autosize: "",
                      clearable: "",
                      maxlength: "15",
                      autocomplete: "off",
                      placeholder: _vm.$t("10000019")
                    },
                    on: {
                      blur: _vm.handleMemoBlur,
                      focus: function($event) {
                        _vm.memoLimitMsg = ""
                      }
                    },
                    model: {
                      value: _vm.secondTemp.memo,
                      callback: function($$v) {
                        _vm.$set(_vm.secondTemp, "memo", $$v)
                      },
                      expression: "secondTemp.memo"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.memoLimitMsg,
                          expression: "!memoLimitMsg"
                        }
                      ],
                      staticClass: "tip-msg-style"
                    },
                    [_vm._v(_vm._s(_vm.$t("8000158")))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "error-msg-style" }, [
                    _vm._v(_vm._s(_vm.memoLimitMsg))
                  ])
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.secondStepCopy == 2
        ? _c("div", [
            _c("h2", { staticClass: "bold title" }, [
              _vm._v(_vm._s(_vm.$t("8000125")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form" }, [
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("10000011")))
                  ]),
                  _vm._v(" "),
                  _c("van-field", {
                    staticClass: "value",
                    attrs: {
                      type: "textarea",
                      rows: "1",
                      autosize: "",
                      clearable: "",
                      autocomplete: "off",
                      placeholder: _vm.$t("8000143")
                    },
                    model: {
                      value: _vm.secondTemp2.blockchainQuery,
                      callback: function($$v) {
                        _vm.$set(_vm.secondTemp2, "blockchainQuery", $$v)
                      },
                      expression: "secondTemp2.blockchainQuery"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.options2.includes(_vm.$parent.protocol)
                ? _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("p", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("8000144")))
                      ]),
                      _vm._v(" "),
                      _c("van-field", {
                        staticClass: "value",
                        attrs: {
                          type: "textarea",
                          rows: "1",
                          autosize: "",
                          clearable: "",
                          maxlength: "20",
                          autocomplete: "off",
                          disabled:
                            _vm.currencyDetails &&
                            !!_vm.currencyDetails.totalCirculation,
                          placeholder: _vm.$t("10000020")
                        },
                        on: { input: _vm.handleTotalCirculation },
                        nativeOn: {
                          paste: function($event) {
                            return _vm.handlePaste($event)
                          }
                        },
                        model: {
                          value: _vm.secondTemp2.totalCirculation,
                          callback: function($$v) {
                            _vm.$set(_vm.secondTemp2, "totalCirculation", $$v)
                          },
                          expression: "secondTemp2.totalCirculation"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "tip-msg-style" }, [
                        _vm._v(_vm._s(_vm.$t("8000145")))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("8000146")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "tip-msg-style",
                      class: { sellColor: _vm.uploadError },
                      staticStyle: { "margin-top": "0" }
                    },
                    [_vm._v(_vm._s(_vm.$t("8000147")))]
                  ),
                  _vm._v(" "),
                  _c("van-uploader", {
                    attrs: {
                      deletable: !(
                        _vm.currencyDetails && !!_vm.currencyDetails.imgs
                      ),
                      disabled:
                        _vm.currencyDetails && !!_vm.currencyDetails.imgs,
                      "max-count": 1,
                      "before-read": _vm.beforeRead,
                      "after-read": _vm.afterRead
                    },
                    on: { delete: _vm.handleDelete },
                    model: {
                      value: _vm.fileList,
                      callback: function($$v) {
                        _vm.fileList = $$v
                      },
                      expression: "fileList"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("8000148")))
                  ]),
                  _vm._v(" "),
                  _vm.currencyDetails && !!_vm.currencyDetails.issueTime
                    ? _c("van-field", {
                        attrs: {
                          disabled: "",
                          type: "textarea",
                          rows: "1",
                          autosize: "",
                          readonly: "",
                          placeholder: _vm.$t("8000149"),
                          value: _vm.secondTemp2.issueTimeStamp
                        }
                      })
                    : _c("van-field", {
                        attrs: {
                          type: "textarea",
                          rows: "1",
                          autosize: "",
                          readonly: "",
                          clickable: "",
                          placeholder: _vm.$t("8000149"),
                          value: _vm.secondTemp2.issueTimeStamp
                        },
                        on: {
                          click: function($event) {
                            _vm.dateShow = true
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c(
                    "van-popup",
                    {
                      attrs: { position: "bottom" },
                      model: {
                        value: _vm.dateShow,
                        callback: function($$v) {
                          _vm.dateShow = $$v
                        },
                        expression: "dateShow"
                      }
                    },
                    [
                      _c("van-datetime-picker", {
                        attrs: {
                          title: _vm.$t("8000149"),
                          type: "date",
                          "confirm-button-text": _vm.$t("300287"),
                          "cancel-button-text": _vm.$t("300111"),
                          "max-date": _vm.maxDate,
                          "min-date": _vm.minDate,
                          formatter: _vm.formatter
                        },
                        on: {
                          confirm: _vm.onConfirm,
                          cancel: function($event) {
                            _vm.dateShow = false
                          }
                        },
                        model: {
                          value: _vm.currentDate,
                          callback: function($$v) {
                            _vm.currentDate = $$v
                          },
                          expression: "currentDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("8000109")))
                  ]),
                  _vm._v(" "),
                  _c("van-field", {
                    staticClass: "value",
                    attrs: {
                      type: "textarea",
                      rows: "1",
                      autosize: "",
                      clearable: "",
                      autocomplete: "off",
                      placeholder: _vm.$t("8000150")
                    },
                    model: {
                      value: _vm.secondTemp2.whitePaper,
                      callback: function($$v) {
                        _vm.$set(_vm.secondTemp2, "whitePaper", $$v)
                      },
                      expression: "secondTemp2.whitePaper"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("8000151")))
                  ]),
                  _vm._v(" "),
                  _c("van-field", {
                    staticClass: "value",
                    attrs: {
                      type: "textarea",
                      rows: "1",
                      disabled:
                        _vm.currencyDetails &&
                        !!_vm.currencyDetails.officialWebsite,
                      autosize: "",
                      clearable: "",
                      autocomplete: "off",
                      placeholder: _vm.$t("8000152")
                    },
                    model: {
                      value: _vm.secondTemp2.officialWebsite,
                      callback: function($$v) {
                        _vm.$set(_vm.secondTemp2, "officialWebsite", $$v)
                      },
                      expression: "secondTemp2.officialWebsite"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("8000183")))
                  ]),
                  _vm._v(" "),
                  _c("van-field", {
                    staticClass: "value",
                    attrs: {
                      type: "textarea",
                      rows: "1",
                      maxlength: "500",
                      disabled:
                        _vm.currencyDetails && !!_vm.currencyDetails.twitter,
                      autosize: "",
                      clearable: "",
                      autocomplete: "off",
                      placeholder: _vm.$t("8000189")
                    },
                    model: {
                      value: _vm.secondTemp2.twitter,
                      callback: function($$v) {
                        _vm.$set(_vm.secondTemp2, "twitter", $$v)
                      },
                      expression: "secondTemp2.twitter"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "error-msg-style" }, [
                    _vm._v(_vm._s(_vm.twitterLimitMsg))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("8000184")))
                  ]),
                  _vm._v(" "),
                  _c("van-field", {
                    staticClass: "value",
                    attrs: {
                      type: "textarea",
                      rows: "1",
                      maxlength: "500",
                      disabled:
                        _vm.currencyDetails && !!_vm.currencyDetails.telegram,
                      autosize: "",
                      clearable: "",
                      autocomplete: "off",
                      placeholder: _vm.$t("8000190")
                    },
                    model: {
                      value: _vm.secondTemp2.telegram,
                      callback: function($$v) {
                        _vm.$set(_vm.secondTemp2, "telegram", $$v)
                      },
                      expression: "secondTemp2.telegram"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "error-msg-style" }, [
                    _vm._v(_vm._s(_vm.telegramLimitMsg))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("8000185")))
                  ]),
                  _vm._v(" "),
                  _c("van-field", {
                    staticClass: "value",
                    attrs: {
                      type: "textarea",
                      rows: "1",
                      maxlength: "500",
                      disabled:
                        _vm.currencyDetails && !!_vm.currencyDetails.discord,
                      autosize: "",
                      clearable: "",
                      autocomplete: "off",
                      placeholder: _vm.$t("8000191")
                    },
                    model: {
                      value: _vm.secondTemp2.discord,
                      callback: function($$v) {
                        _vm.$set(_vm.secondTemp2, "discord", $$v)
                      },
                      expression: "secondTemp2.discord"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "error-msg-style" }, [
                    _vm._v(_vm._s(_vm.discordLimitMsg))
                  ])
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.secondStepCopy == 3
        ? _c("div", [
            _c("h2", { staticClass: "bold title" }, [
              _vm._v(_vm._s(_vm.$t("8000125")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form" },
              [
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("p", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("8000108")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "van-checkbox-group",
                      {
                        attrs: {
                          direction: "horizontal",
                          "checked-color": "#FFC72B"
                        },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.secondTemp3.checkList,
                          callback: function($$v) {
                            _vm.$set(_vm.secondTemp3, "checkList", $$v)
                          },
                          expression: "secondTemp3.checkList"
                        }
                      },
                      _vm._l(_vm.languageListData, function(item, key) {
                        return _c(
                          "van-checkbox",
                          { key: key, attrs: { name: item.language } },
                          [
                            _c(
                              "van-button",
                              {
                                class: {
                                  "is-checked": _vm.secondTemp3.checkList.includes(
                                    item.language
                                  )
                                }
                              },
                              [_vm._v(_vm._s(item.name) + "\n            ")]
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.secondTemp3.currencyInfoContentRequest, function(
                  item,
                  index
                ) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "form-item",
                      class: item.language == "fa" ? "form-item-fa" : ""
                    },
                    [
                      _c("p", { staticClass: "label required-fields" }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _vm._v(" "),
                      _c("van-field", {
                        staticClass: "value",
                        attrs: {
                          autosize: "",
                          rows: "4",
                          "show-word-limit": "",
                          type: "textarea",
                          clearable: "",
                          maxlength: "2000",
                          autocomplete: "off",
                          placeholder: item.placeholderContent
                        },
                        model: {
                          value: item.content,
                          callback: function($$v) {
                            _vm.$set(item, "content", $$v)
                          },
                          expression: "item.content"
                        }
                      })
                    ],
                    1
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-buttons-box" },
        [
          _c(
            "van-button",
            { staticClass: "back-btn", on: { click: _vm.handleBack } },
            [_vm._v(_vm._s(_vm.$t("10000012")))]
          ),
          _vm._v(" "),
          _c(
            "van-button",
            {
              staticClass: "next-btn",
              attrs: {
                loading: _vm.submitButtonLoading,
                disabled: _vm.buttonDisabled
              },
              on: { click: _vm.nextStep }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("10000013")) + "\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "priceTick-popup",
          model: {
            value: _vm.priceTickTipModel,
            callback: function($$v) {
              _vm.priceTickTipModel = $$v
            },
            expression: "priceTickTipModel"
          }
        },
        [
          _c(
            "div",
            [
              _c("h2", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.$t("8000120")))
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("8000137")))]),
              _vm._v(" "),
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      _vm.priceTickTipModel = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("10000018")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "priceTick-popup",
          model: {
            value: _vm.memoTipModel,
            callback: function($$v) {
              _vm.memoTipModel = $$v
            },
            expression: "memoTipModel"
          }
        },
        [
          _c(
            "div",
            [
              _c("h2", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.$t("8000071")))
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("8000141")))]),
              _vm._v(" "),
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      _vm.memoTipModel = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("10000018")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a8f86c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a8f86c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/freeZone/createSymbol/secondStep.vue
// module id = ueEa
// module chunks = 0